<div class="flex min-h-screen bg-white font-sans">
  <div
    class="relative hidden overflow-hidden bg-gradient-to-b from-gray-100 to-gray-200 md:flex md:w-1/2"
  >
    <!-- Decorative: blurred white shapes over a neutral grey read as cloud, sharp at any size. Each
         drifts at its own pace so they slide past one another; with reduced motion asked for, they
         stand still. -->
    <div aria-hidden="true">
      <div
        class="absolute -left-1/4 top-12 h-1/5 w-3/4 animate-cloud-drift rounded-full bg-white blur-2xl will-change-transform motion-reduce:animate-none"
      ></div>
      <div
        class="absolute left-2/3 top-1/4 h-1/6 w-2/5 animate-cloud-drift-back rounded-full bg-white blur-2xl will-change-transform motion-reduce:animate-none"
      ></div>
      <div
        class="absolute left-1/3 top-1/3 h-1/6 w-3/5 animate-cloud-drift-back rounded-full bg-white/90 blur-2xl will-change-transform motion-reduce:animate-none"
      ></div>
      <div
        class="absolute -left-1/3 top-2/3 h-1/4 w-4/5 animate-cloud-drift-slow rounded-full bg-white blur-2xl will-change-transform motion-reduce:animate-none"
      ></div>
    </div>
    <div class="relative flex w-full flex-col justify-center p-10 xl:p-16">
      <ng-content select="[publicPageAside]"></ng-content>
    </div>
  </div>
  <div class="flex min-w-0 flex-1 flex-col px-4 py-6 md:px-10">
    <header class="flex items-center justify-end gap-4">
      <a
        href="mailto:telemetrysupport.telular@ametek.com"
        class="flex items-center gap-1.5 text-sm text-theme-600 no-underline hover:underline"
      >
        <mat-icon aria-hidden="true" class="tl-icon-sm">help_outline</mat-icon>
        {{ 'AccessLink.ContactSupport' | translate }}
      </a>
    </header>
    <main class="flex flex-1 items-center justify-center py-12">
      <div class="flex w-full max-w-sm flex-col gap-4">
        <!-- The theme's logo, or SmartTank's on an unthemed visit, then "/ AMETEK" either way. -->
        <div class="mb-2 flex items-center justify-center gap-1">
          <a
            *ngIf="logoHyperlink; else plainLogo"
            [href]="logoHyperlink"
            target="_blank"
            rel="noopener"
            class="flex min-w-0"
          >
            <ng-container *ngTemplateOutlet="plainLogo"></ng-container>
          </a>
          <ng-template #plainLogo>
            <img
              [src]="logoUrl"
              alt=""
              class="block h-8 min-w-0 max-w-40 bg-logo object-contain sm:h-10 sm:max-w-48"
            />
          </ng-template>
          <img src="assets/images/separator.png" alt="" class="block h-4 sm:h-5" />
          <img src="assets/images/ametek.png" alt="" class="block h-4 min-w-0 object-contain sm:h-5" />
        </div>
        <ng-content></ng-content>
      </div>
    </main>
  </div>
</div>
